import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "container py-5",
  style: {"min-height":"500px"}
}
const _hoisted_2 = { class: "text-body-1 text-center" }
const _hoisted_3 = {
  key: 0,
  class: "col-12 col-md-4 my-4",
  "data-aos": "fade-up"
}

import { ref, onMounted } from 'vue';
import { useConfigStore, useGlobalStore } from '@/stores';

// stores

export default /*#__PURE__*/_defineComponent({
  __name: 'IdentitiesList',
  setup(__props) {

const configStore = useConfigStore();
const globalStore = useGlobalStore();

const showImage = ref(false);
const imageUrl = ref('');

onMounted(() => {
  globalStore.fetchIdentities(undefined);
});

return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(globalStore).identities, (identity, index) => {
            return (_openBlock(), _createBlock(_component_v_col, {
              key: index,
              cols: "12",
              md: "3"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card, { variant: "text" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_title, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_img, {
                          src: (identity.fileLink as string),
                          alt: _unref(configStore).stringLang(identity.titleAr, identity.titleEn),
                          height: 150,
                          contain: "",
                          onClick: 
                () => {
                  showImage.value = !showImage.value;
                  imageUrl.value = identity.fileLink as string;
                }
              
                        }, null, 8, ["src", "alt", "onClick"])
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_v_card_text, null, {
                      default: _withCtx(() => [
                        _createElementVNode("p", _hoisted_2, [
                          _createElementVNode("b", null, _toDisplayString(_unref(configStore).stringLang(identity.titleAr, identity.titleEn)), 1)
                        ])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }),
      (_unref(globalStore).identities.length == 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.$t('COMING_SOON')), 1))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_v_dialog, {
      modelValue: showImage.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showImage).value = $event)),
      class: "w-25 h-50 bg-white"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_img, { src: imageUrl.value }, null, 8, ["src"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})